import React, { useMemo } from 'react'

import { Row, Text } from 'Components/UI'

import {
  DateGlyph,
  GolfFieldGlyph,
  LocationGlyph,
  PresenterGlyph,
} from 'Assets/Svg/Section/EventsList'

export enum EventsListGalleryCardTextRowKind {
  Date = 'date',
  Name = 'name',
  Presenter = 'presenter',
  Address = 'address',
}

type Props = {
  kind: EventsListGalleryCardTextRowKind
  text?: string
}

function EventsListGalleryCardTextRow({ kind, text }: Props) {
  const icon = useMemo(() => {
    switch (kind) {
      case EventsListGalleryCardTextRowKind.Date:
        return DateGlyph
      case EventsListGalleryCardTextRowKind.Name:
        return GolfFieldGlyph
      case EventsListGalleryCardTextRowKind.Presenter:
        return PresenterGlyph
      default:
        return LocationGlyph
    }
  }, [kind])

  if (!text) return null

  return (
    <Row alignCenter gap={4}>
      {icon()}

      <Text important medium screen18>
        {text}
      </Text>
    </Row>
  )
}

export default EventsListGalleryCardTextRow
